export default __webpack_public_path__ + "static/sangbleukingdom-light-webfont-be938d2737c6fec8b37a2abc68803466.woff";